import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a desktop computer setup authored at floor level (the
// builder sets it on a desk): a monitor on a small stand facing +Z, a keyboard
// slab in front and a tower case beside them.
const MATTE_BLACK = "#2e2e30";
const SCREEN = "#7f97a8";
const STEEL = "#aab2b8";
const DARK_GLASS = "#3a3f44";

export const desktopComputer = defineModel({
  id: "desktop-computer",
  batchId: "modern",
  name: "Desktop Computer",
  tags: ["modern", "interior", "appliance", "electronics", "office", "computer"],
  summary: "A desktop setup: monitor on a stand, keyboard and a tower case.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    return [
      // monitor stand base
      { geometry: new THREE.BoxGeometry(0.22, 0.02, 0.14), color: MATTE_BLACK, position: [-0.1, 0.01, -0.12] },
      // stand neck
      { geometry: new THREE.BoxGeometry(0.04, 0.12, 0.03), color: MATTE_BLACK, position: [-0.1, 0.08, -0.14] },
      // monitor panel
      { geometry: new THREE.BoxGeometry(0.56, 0.33, 0.03), color: MATTE_BLACK, position: [-0.1, 0.3, -0.13] },
      // screen face on +Z
      { geometry: new THREE.BoxGeometry(0.52, 0.29, 0.01), color: SCREEN, position: [-0.1, 0.3, -0.113] },
      // keyboard slab in front
      { geometry: new THREE.BoxGeometry(0.4, 0.02, 0.14), color: MATTE_BLACK, position: [-0.1, 0.01, 0.12] },
      // key field
      { geometry: new THREE.BoxGeometry(0.36, 0.008, 0.1), color: DARK_GLASS, position: [-0.1, 0.024, 0.12] },
      // mouse
      { geometry: new THREE.BoxGeometry(0.06, 0.025, 0.09), color: MATTE_BLACK, position: [0.16, 0.0125, 0.14] },
      // tower case beside the monitor
      { geometry: new THREE.BoxGeometry(0.18, 0.42, 0.4), color: MATTE_BLACK, position: [0.32, 0.21, -0.08] },
      // tower front trim strip
      { geometry: new THREE.BoxGeometry(0.14, 0.36, 0.01), color: STEEL, position: [0.32, 0.22, 0.125] },
    ];
  },
  animations: [],
});
